export const copyObject = <T>(obj: T): T => {
  return structuredClone(obj);
};
